import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {SpriteView} from './SpriteView'
import {PIXI} from '@colonist/pixi'

export class SpriteExpansionArrowView extends SpriteView {
    private toggled: boolean
    private readonly originalContrainerWidth: number
    private readonly originalArrowWidth: number

    constructor(x: number, y: number, container: PIXI.Container, padding?: number, isWhite: boolean = false) {
        const textureName = isWhite ? Sprites.icon_arrow_player_profile_white : Sprites.icon_arrow_player_profile
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(textureName)
        const arrowHeightToWidth = texture.height / texture.width
        const arrowW = container.width * 0.35
        const arrowH = arrowW * arrowHeightToWidth
        super(x, y, arrowW, arrowH, container, texture, padding)

        this.toggled = false
        this.originalContrainerWidth = container.width
        this.originalArrowWidth = arrowW
        this.centerYInParent()
        this.flipArrow()
    }

    flipArrow() {
        this.rotate((this.rotation * 180 / Math.PI) + 180)
        this.centerXInParent()
        this.toggled = !this.toggled
    }

    arrowPointLeft() {
        if(this.toggled) return
        this.width = - this.width
        this.centerXInParent()
        this.toggled = true
    }

    arrowPointRight() {
        if(!this.toggled) return
        this.width = -this.originalArrowWidth
        this.centerXInParent()
        this.toggled = false
    }
}
